<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast">
    <div class="uk-modal-dialog uk-modal-body uk-width-xlarge uk-text-center uk-padding">
      <div class="uk-margin">
        <md-icon class="md-size-2x" :class="getHeaderModal().class">{{ getHeaderModal().icon }}</md-icon>
      </div>
      <div class="uk-margin">
        <div v-for="(text,index) in preValidateInfoContent" :key="index">
          <span v-html="text"></span>
        </div>
        <div class="uk-margin" v-if="!preValidateInfoContent.length">
          нет данных
        </div>
        <div class="uk-margin-large-top uk-grid uk-grid-small uk-flex-center" v-if="!disableConfirmButton">
          <div>
            <button
                type="button"
                class="uk-button tm-button-grey"
                @click="closeModal()"
            >
              {{ local_page_keys.button_cancel }}
            </button>
          </div>
          <div>
            <button
                type="button"
                class="uk-button tm-button-success"
                @click="submitFile()">
              {{ local_page_keys.button_send }}
            </button>
          </div>
        </div>
        <div class="uk-margin-large-top uk-grid uk-grid-small uk-flex-center" v-else-if="disableConfirmButton">
          <div>
            <button
                type="button"
                class="uk-button tm-button-grey"
                @click="closeModal()">
              {{ local_page_keys.button_close }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    preValidateInfoContent: {type: [Array, Object]},
    modalType: {
      type: String,
      require: true
    },
    disableConfirmButton: {
      type: Boolean,
      require: true
    },
  },
  methods: {
    closeModal() {
      this.$emit('close', true);
    },
    submitFile() {
      this.$emit('send', true, 'ignore_pre_validate');
    },
    getHeaderModal() {
      let data = {class: 'uk-text-' + this.modalType, icon: this.modalType}
      if (this.modalType === 'error') {
        data.class = 'uk-text-danger';
      }
      return data;
    }
  },
}
</script>